export default __webpack_public_path__ + "img/c20a010036a307e2913a8dd8e355a76e.png";